import type { ReactNode } from 'react';

import { Typography } from '@mui/material';

export type AuthStatusMessageProps = {
  title: string;
  subtitle: ReactNode;
  icon: ReactNode;
  button?: ReactNode;
};

export const AuthStatusMessage = ({ title, subtitle, icon, button }: AuthStatusMessageProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-6">
        {icon}
        <div className="flex flex-col gap-4">
          <Typography className="font-bold" fontSize={28} variant="h1">
            {title}
          </Typography>
          {subtitle}
        </div>
      </div>
      {button && <div className="flex gap-3">{button}</div>}
      <Typography className="text-grey60" variant="body2">
        Need help? Reach out to{' '}
        <a className="text-primary-main no-underline" href="mailto:support@truv.com">
          support@truv.com
        </a>
        .
      </Typography>
    </div>
  );
};

AuthStatusMessage.displayName = 'AuthStatusMessage';
